const excursionsWithinTabs = (tab: HTMLElement, index: number, headers: HTMLElement[]) => {
  const hits = tab.querySelectorAll('.ais-Hits-item') ?? [];
  const countSpan = headers[index].querySelector('.cmp-tabs__tab-count');
  if (countSpan) {
    countSpan.textContent = ` (${hits.length})`;
  } else {
    const countEl = document.createElement('span');
    countEl.classList.add('cmp-tabs__tab-count');
    countEl.textContent = ` (${hits.length})`;
    headers[index].appendChild(countEl);
  }

  if (hits.length === 0) {
    headers[index].classList.add('hide');
  } else {
    headers[index].classList.remove('hide');
  }
};

export const excursionsCounterLogic = (container: HTMLElement) => {
  const tabsContentContainers = container.querySelectorAll('.cmp-tabs__tabpanel') ?? [];
  const tabHeaderContainers = container.querySelectorAll('.cmp-tabs__tab') ?? [];
  if (tabsContentContainers.length === 0 || tabHeaderContainers.length === 0) return;

  tabsContentContainers.forEach((tab, index) => {
    excursionsWithinTabs(
      tab as HTMLElement,
      index,
      Array.from(tabHeaderContainers) as HTMLElement[]
    );

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const nodesArray = Array.from(mutation.addedNodes) as HTMLElement[];
        if (nodesArray.length > 0) {
          nodesArray.forEach((node) => {
            const isHits = node?.classList?.contains('ais-Hits');

            if (isHits) {
              excursionsWithinTabs(
                tab as HTMLElement,
                index,
                Array.from(tabHeaderContainers) as HTMLElement[]
              );

              observer.disconnect();
            }
          });
        }
      });
    });

    observer.observe(tab, {
      childList: true,
      subtree: true,
    });
  });
};
